import { yupResolver } from '@hookform/resolvers/yup';
import { HttpStatusCode, isAxiosError } from 'axios';
import { useState } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { showErrorDialog } from 'v3/data/store/error/actions';
import { showSnackbar } from 'v3/data/store/snackbar/actions';
import { RoutesEnum } from 'v3/routes/enum';
import { createStore } from 'v3/services/api';
import { IGetJazzStoreDataResponse } from 'v3/services/interfaces/response';
import { storeSchema } from 'v3/shared/schemas/fieldsStore';
import { FlexButton } from '../Button/FlexButton';
import { StoreAddress } from './StoreAddress';
import { StoreIdentifier } from './StoreIdentifier';
import { StoreInformation } from './StoreInformation';
import { Container } from './styles';
import { FormValues } from './types';

export const FieldStore = () => {
  const navigate = useNavigate();
  const methods = useForm<FormValues>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(storeSchema),
  });

  const {
    formState: { isValid },
  } = methods;

  const [storeData, setStoreData] = useState<any>('');
  const [customStoreName, setCustomStoreName] = useState<string | undefined>();

  const onStoreDataChange = (data: IGetJazzStoreDataResponse) => {
    setCustomStoreName(undefined);
    setStoreData(data);
  };

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    try {
      const { confirmPassword, ...requestData } = data;
      const requestBody = {
        ...requestData,
        customStoreName: customStoreName,
      };

      await createStore(requestBody);
      showSnackbar('Loja cadastrada com sucesso!', 'success', true);
      navigate(RoutesEnum.StoresList);
    } catch (error) {
      if (isAxiosError(error)) {
        if (error.response?.status === HttpStatusCode.Conflict) {
          showSnackbar('CNPJ ou Email já está vinculado a uma loja. Tente cadastrar com outro', 'error', true);
        } else {
          showErrorDialog('Erro ao cadastrar loja. Tente novamente.', error);
        }
        console.error('Error creating store:', error);
      }
    }
  };

  return (
    <FormProvider {...methods}>
      <Container>
        <StoreIdentifier control={methods.control} onStoreDataChange={onStoreDataChange} />
        <StoreInformation
          name={customStoreName ?? storeData?.name}
          email={storeData?.email}
          onNameChange={(newName) => setCustomStoreName(newName)}
        />
        <StoreAddress {...storeData.address} />
        <FlexButton text="Salvar" size="small" handleClick={methods.handleSubmit(onSubmit)} disabled={!isValid} />
      </Container>
    </FormProvider>
  );
};
